import IconAsMaskImage from '../IconAsMaskImage'

const Warning = ({ pureSvg, className, color }) => {
  const svg = (
    <>
      <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.3">
          <rect x="4.75" y="5.25" width="19.5" height="19.5" rx="9.75" stroke="#D92D20" strokeWidth="1.5" />
        </g>
        <g opacity="0.1">
          <rect x="1" y="1.5" width="27" height="27" rx="13.5" stroke="#D92D20" strokeWidth="1.5" />
        </g>
        <path
          d="M14.5 12.5V15M14.5 17.5H14.5063M20.75 15C20.75 18.4518 17.9518 21.25 14.5 21.25C11.0482 21.25 8.25 18.4518 8.25 15C8.25 11.5482 11.0482 8.75 14.5 8.75C17.9518 8.75 20.75 11.5482 20.75 15Z"
          stroke="#D92D20"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default Warning
